/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AcceptQuarantinedRegistrationDataParser = 
/* #__PURE__ */ parsers.object([
    ['tenantRoleId', codecNumber, 'tenant_role_id'],
]);
export class AcceptQuarantinedRegistrationData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AcceptQuarantinedRegistrationDataParser.decode(input).map(res => new AcceptQuarantinedRegistrationData(res));
    }
    static unsafeDecode(input) {
        return AcceptQuarantinedRegistrationData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AcceptQuarantinedRegistrationDataParser.encode(data);
    }
    static schema() {
        return AcceptQuarantinedRegistrationDataParser.schema();
    }
}
